/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
} from 'reactstrap';
// import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
// import { get, del } from '../../helpers/api_helper';

function TVPallets(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [signal] = useState(0);

  document.title = t('Processed TV Pallets');

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="6">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{t('Processed TV Pallets')}</CardHeader>
              <CardBody>
                <Can i="see" this="TVs">
                  <BaseGrid
                    url="/api/tvs/pallets"
                    hasSearch
                    shouldUpdate={signal}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                          link: {
                            to: '/tvs/pallets/%id%',
                          },
                          format: (v) => v.toString(36).toUpperCase(),
                        },
                        class: {
                          label: 'Classification',
                          sort: true,
                          style: { textTransform: 'capitalize', fontSize: '19px', fontWeight: 'bold' },
                        },
                        lane: {
                          label: 'Lane',
                          sort: true,
                          format: (value) => {
                            if (value) {
                              return `${value}`;
                            }
                            return t('not tracked');
                          },
                        },
                        truck: {
                          label: 'Truck',
                          sort: true,
                          html: true,
                          format: (value) => {
                            if (value) {
                              return `${value.supplier && value.supplier.name}: <a href="/sourcing/truck/${value.id}">${value.reference}</a>`;
                            }
                            return t('not loaded');
                          },
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="TVs"><p>{t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

TVPallets.defaultProps = {
  t: (x) => (x),
};

TVPallets.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVPallets));
